import * as infoboxActions from '../../actions/infobox.actions';
import * as requestsActions from '../../actions/requests.actions';
import {
  REQUEST_REFRESH_RESOURCE_APPLY,
  REQUEST_REFRESH_RESOURCE_CLEAR,
  REQUEST_REFRESH_RESOURCE_NO_OP,
  getPatientInfoboxFields,
  readBillerVerificationFromRequest,
  readChiefComplaintFromRequest,
  readCoveragesFromRequest,
  readPatientFromRequest,
} from '../../helpers/requestRefresh.helper';

const getPatientRefreshActions = latestRequest => {
  const patientFields = readPatientFromRequest(latestRequest);

  return [
    requestsActions.applyPatientPartialRefresh({
      infoboxFields: getPatientInfoboxFields(latestRequest),
      patientFields: {
        address1: patientFields.address1,
        address2: patientFields.address2,
        city: patientFields.city,
        state: patientFields.state,
        zip: patientFields.zip,
      },
    }),
  ];
};

const getCoverageRefreshActions = (latestRequest, coveragesToApply) => {
  const latestCoverages = readCoveragesFromRequest(latestRequest);
  const refreshedCoverages = {};

  Object.keys(coveragesToApply || {}).forEach(coordinationTypeId => {
    refreshedCoverages[coordinationTypeId] = latestCoverages[coordinationTypeId] || null;
  });

  return [infoboxActions.applyCoveragePartialRefresh(refreshedCoverages), infoboxActions.checkPayerRules()];
};

const getChiefComplaintRefreshActions = latestRequest => {
  const chiefComplaint = readChiefComplaintFromRequest(latestRequest);

  return [requestsActions.applyChiefComplaintPartialRefresh(chiefComplaint)];
};

const getBilledToFacilityRefreshActions = latestRequest => [
  infoboxActions.applyBilledToFacilityPartialRefresh(!!latestRequest.isBilledToFacility),
];

const getBillerVerificationRefreshActions = latestRequest => {
  const { isBillerVerified, billerVerifiedAt, billerVerifiedBy } = readBillerVerificationFromRequest(latestRequest);

  return [
    requestsActions.applyBillerVerificationPartialRefresh({
      isBillerVerified: !!isBillerVerified,
      billerVerifiedAt,
      billerVerifiedBy,
    }),
  ];
};

const getBillerVerificationClearActions = () => [
  requestsActions.applyBillerVerificationPartialRefresh({
    isBillerVerified: false,
    billerVerifiedAt: '',
    billerVerifiedBy: null,
  }),
];

export const getPartialRequestRefreshActions = (latestRequest, resourcesToApply) => {
  const resources = {
    patient: REQUEST_REFRESH_RESOURCE_NO_OP,
    coverages: {},
    chiefComplaint: REQUEST_REFRESH_RESOURCE_NO_OP,
    isBilledToFacility: REQUEST_REFRESH_RESOURCE_NO_OP,
    billerVerification: REQUEST_REFRESH_RESOURCE_NO_OP,
    ...resourcesToApply,
  };
  const coveragesToApply = Object.keys(resources.coverages || {}).reduce((acc, coordinationTypeId) => {
    if (resources.coverages[coordinationTypeId] === REQUEST_REFRESH_RESOURCE_APPLY) {
      acc[coordinationTypeId] = REQUEST_REFRESH_RESOURCE_APPLY;
    }

    return acc;
  }, {});
  const actions = [];

  if (resources.patient === REQUEST_REFRESH_RESOURCE_APPLY) {
    actions.push(...getPatientRefreshActions(latestRequest));
  }

  if (Object.keys(coveragesToApply).length) {
    actions.push(...getCoverageRefreshActions(latestRequest, coveragesToApply));
  }

  if (resources.chiefComplaint === REQUEST_REFRESH_RESOURCE_APPLY) {
    actions.push(...getChiefComplaintRefreshActions(latestRequest));
  }

  if (resources.isBilledToFacility === REQUEST_REFRESH_RESOURCE_APPLY) {
    actions.push(...getBilledToFacilityRefreshActions(latestRequest));
  }

  if (resources.billerVerification === REQUEST_REFRESH_RESOURCE_APPLY) {
    actions.push(...getBillerVerificationRefreshActions(latestRequest));
  }

  if (resources.billerVerification === REQUEST_REFRESH_RESOURCE_CLEAR) {
    actions.push(...getBillerVerificationClearActions());
  }

  return actions;
};
